import { render, staticRenderFns } from "./addRouter.vue?vue&type=template&id=407fb5e9&scoped=true&"
import script from "./addRouter.vue?vue&type=script&lang=js&"
export * from "./addRouter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407fb5e9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\sdk_manage_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('407fb5e9')) {
      api.createRecord('407fb5e9', component.options)
    } else {
      api.reload('407fb5e9', component.options)
    }
    module.hot.accept("./addRouter.vue?vue&type=template&id=407fb5e9&scoped=true&", function () {
      api.rerender('407fb5e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/routes/components/addRouter.vue"
export default component.exports